import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ItemCountBadgeProps {
  count: number;
}

const ItemCountBadge = (props: ItemCountBadgeProps) => {
  const { t } = useTranslation();
  const { count } = props;

  return (
    <Chip
      label={t("outboundDeliveryItemCountBadge", { count })}
      variant="filled"
      size="small"
    />
  );
};

export default ItemCountBadge;
